import axios from 'axios'
import { debounce } from 'lodash'

export const fetchPostalCode = debounce(async (address, api_url) => {
  let processedAddress = address
  let originalPrefix = ''

  const match = address.match(/^(\d+)\s*(.*)/)
  if (match) {
    originalPrefix = match[1]
    processedAddress = match[2].trim()
  }

  if (processedAddress.length >= 6) {
    try {
      const baseURL = `${api_url}/v1/fetch-postal-code`
      const response = await axios.post(baseURL, null, {
        headers: {
          "ngrok-skip-browser-warning": "69420"
        },
        params: { address: processedAddress }
      })
      
      if (response.status === 200 && response.data) {
        return response.data
      }
      
      return { address: originalPrefix + processedAddress }
    } catch (error) {
      console.error('Error fetching postal code:', error)
      return { address: originalPrefix + processedAddress }
    }
  }
}, 2000)

// Function to extract postal code from address
export const extractPostalCode = async (address, api_url) => {
  let processedAddress = address.trim()
  
  // Remove any leading postal code from input
  const match = address.match(/^(\d+)\s*(.*)/)
  if (match) {
    processedAddress = match[2].trim()
  }

  // Only proceed if we have enough characters to work with
  if (processedAddress.length >= 6) {
    try {
      const baseURL = `${api_url}/v1/fetch-postal-code`
      const response = await axios.post(baseURL, null, {
        headers: {
          "ngrok-skip-browser-warning": "69420"
        },
        params: { address: processedAddress }
      })
      
      if (response.status === 200 && response.data?.postal_code) {
        return response.data.postal_code
      }
    } catch (error) {
      console.error('Error fetching postal code:', error)
    }
  }
  
  return null
}

